import { render } from "./google_drive_document_settings.vue?vue&type=template&id=06442f82"
import script from "./google_drive_document_settings.vue?vue&type=script&lang=js"
export * from "./google_drive_document_settings.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/google_drive_document_settings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06442f82"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06442f82', __exports__)) {
    api.reload('06442f82', __exports__)
  }
  
  module.hot.accept("./google_drive_document_settings.vue?vue&type=template&id=06442f82", () => {
    api.rerender('06442f82', render)
  })

}


export default __exports__